export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_plateforme-defar/artifacts/7admhybh_690665343_1506104017753522_325855472905522352_n.jpg";
export const EMBLEM_URL = LOGO_URL;

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1637166514815-8b923a08f8e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
export const PRESIDENT_IMAGE =
  "https://customer-assets.emergentagent.com/job_plateforme-defar/artifacts/evvdfdf8_WhatsApp%20Image%202026-06-21%20at%2020.29.21.jpeg";
export const AGENDA_FLYER =
  "https://customer-assets.emergentagent.com/job_plateforme-defar/artifacts/blv7utei_image.png";
export const DAKAR_IMAGE =
  "https://images.unsplash.com/photo-1758061329486-4f7b4a09d77d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
export const COMMUNITY_IMAGE =
  "https://images.pexels.com/photos/27471164/pexels-photo-27471164.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const WHATSAPP_NUMBER = "221770000000";

export const SITE_URL = "https://defar.sn";
export const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/4b8b4640-30b7-4f2f-8acb-83ad67851ad0/images/bbea872d9d00cdfa13745011c3ebd76d8fc851730ae8ff751ea15356a1cd355a.png";

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Le mouvement", to: "/le-mouvement" },
  { label: "Le président", to: "/le-president" },
  { label: "Actualités", to: "/actualites" },
  { label: "Agenda", to: "/agenda" },
  { label: "Comités", to: "/comites" },
  { label: "Contact", to: "/contact" },
];

export const CATEGORY_LABELS = {
  actualite: "Actualité",
  communique: "Communiqué",
  action: "Action terrain",
};

export const REGIONS = [
  "Dakar", "Thiès", "Saint-Louis", "Ziguinchor", "Kaolack", "Diourbel",
  "Louga", "Fatick", "Kolda", "Tambacounda", "Kaffrine", "Kédougou",
  "Matam", "Sédhiou", "Diaspora",
];
